import { render, staticRenderFns } from "./StepResult.vue?vue&type=template&id=3724dfed&scoped=true"
import script from "./StepResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepResult.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StepResult.vue?vue&type=style&index=0&id=3724dfed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724dfed",
  null
  
)

export default component.exports